<template>

<DialogBox :settings="settings" :disabled="!isFormValid" @save="sendSMS" @show="showingDialog" @hide="hidingDialog">

        <div style="position:relative" class="pr-4 pl-4 pb-4">   
            <v-combobox v-model="sms.recipients" single-line label="Recipients" chips multiple :items="contactsWithMobiles" return-object item-text="fullName"></v-combobox>
            <v-textarea v-model="sms.message" :rows="3" :label="prefix" :hint="suffix" persistent-hint />     
        </div>
  
</DialogBox>

</template>

<script>
import Vue from 'vue'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import MergeHelpers from '../helpers/MergeHelpers'
import FirebaseHelpers from '../helpers/FirebaseHelpers'
import DataHelpers from '../helpers/DataHelpers'
import LookupData from '../helpers/LookupData'
import StringHelpers from '../helpers/StringHelpers'
import Utilities from '../helpers/Utilities'

import DialogBox from '../ui-elements/DialogBox'
import ContactHelpers from '../helpers/ContactHelpers';


export default {
props:{
    settings: Object,
    recipients: Array,
    message: String,
    returnObject: Object,
},
components:{
    'DialogBox': DialogBox

},
data() {
    return {
        sms: {
            recipients: [],
            message: '',
        },
        prefix: '',
        suffix: '',
    }
},
computed: {

    elements() {
        return this.$store.getters.elements
    },

    fields() {
        return [
            ...this.elements,
            {name: 'greeting', value:this.greeting}
        ]
    },

    greeting() {
        return ContactHelpers.greetingFromContacts(this.sms.recipients)
        // return this.sms.recipients.filter(o => o.firstName).map(o => o.firstName).join(' and ')
    },

    contactsWithMobiles() {
        return this.$store.getters.transactionContacts.filter(o => o.mobile)
    },

    isFormValid() {
        return true
    }

    
},
methods: {
    sendSMS() {
        let message = this.prefix + '...' + this.sms.message + ' (' +  this.suffix + ')'
        let mobiles = this.sms.recipients.map(o => (o.mobile || o) )
        console.log('mobiles', mobiles)
        mobiles.forEach(function(mobile){
            Utilities.sendSMS(message, mobile)
        })

        this.$emit('sent', this.returnObject)
    },

    showingDialog() {
        this.sms.recipients = this.recipients
        this.sms.message = MergeHelpers.merge( this.message, this.fields )
        if(!this.suffix) {
            DataHelpers.getSettings('sms').then((settings) => {
                this.suffix = settings.suffix
                this.prefix = settings.prefix
            })
        }
    },

    hidingDialog() {
        setTimeout( () => { 
            this.sms = {
                message: '',
                recipients: []
            }
        }, 300)            
    }

},

created() {
    this.settings.saveLabel = 'Send'
    this.settings.height = '350px'

},

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


</style>


// WEBPACK FOOTER //
// SmsDialog.vue?7620901c